<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/10D6iFB/tc-custom/9781460387177.jpg?1740465834369" alt="This image is the cover for the book Christmas on the Silver Horn Ranch, Men of the West"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Christmas on the Silver Horn Ranch, Men of the West
      </h1>
      <p class="bookDescription body article font2">
        <b>From a <i>New York Times</i>–bestselling author, an injured firefighter goes under the care of an ER nurse in this opposites-attract holiday romance.</b><br/><br/>You can put him in a cast, but you can’t keep Bowie Calhoun down. Broken ankle or no, the flirty cowboy has no intention of spending Christmas lying in bed—unless he has company.<br/><br/>The serious-minded nurse who is hired to tend his wounds isn’t biting. Ava Archer is a widow; she lost her husband to war. She’d never consider falling for a patient, especially not a “wild child” like Bowie, who battles fires for a living and takes risks just for fun. But the longer Ava stays on at the Silver Horn Ranch, the harder it is to fight Bowie’s magnetism. ‘Tis the season to be tempted. Is Ava ready to take a risk of her own—on love?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Stella Bagwell
      </h2>
      
      <p class="authorDescription body article">The author of over seventy-five titles for Harlequin, Stella Bagwell writes about familes, the West, strong, silent men of honor and the women who love them. She credits her loyal readers and hopes her stories have brightened their lives in some small way. A cowgirl through and through, she recently learned how to rope a steer. Her days begin and end helping her husband on their south Texas ranch. In between she works on her next tale of love. Contact her at stellabagwell@gmail.com</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?65edf680